import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { deleteMobileAppsLink } from 'redux/links/actions';

import TooltipCommon from 'components/common/TooltipCommon';
import TooltipButton from 'components/elements/buttons/TooltipButton';

import './MobileAppDeleteIcon.css';


class MobileAppDeleteIcon extends Component {
  static propTypes = {
    deleteMobileAppsLink: PropTypes.func.isRequired,
    linkId: PropTypes.number.isRequired,
    device: PropTypes.string.isRequired,
  };

  state = {
    popupOpen: false,
  };

  onPopupClose = () => {
    this.setState({ popupOpen: false });
  };

  renderTooltipContent = () => (
    <Translation>
      {(t) => (
        <div className="tooltip-content">
          <div className="message-text">
            <div>{t("Are you sure you want to delete this app link?")}</div>
            <div>{t("You can't undo this action.")}</div>
          </div>

          <div className="buttons-block">
            <TooltipButton
              onClick={() => this.setState({ popupOpen: false })}
            >
              {t("Cancel")}
            </TooltipButton>
            <TooltipButton
              negative
              onClick={() => this.props.deleteMobileAppsLink(this.props.linkId)}
            >
              {t("Delete")}
            </TooltipButton>
          </div>
        </div>
      )}
    </Translation>
  );

  renderDeleteButtonDesktop = () => (
    <div className="mobile-app-link-delete-icon__component">
      <div
        className="desktop-icon"
        onClick={() => this.setState({popupOpen: true})}
        role="button"
        tabIndex={-1}
      />
    </div>
  );

  renderDeleteButtonMobile = () => (
    <Translation>
      {(t) => (
        <div className="mobile-app-link-delete-icon__component">
          <div
            className="mobile-icon"
            onClick={() => this.setState({ popupOpen: true })}
            role="button"
            tabIndex={-1}
          >
            <div className="icon" />
            <div className="undertext">{t("Delete")}</div>
          </div>
        </div>
      )}
    </Translation>
  );

  render() {
    return (
      <Translation>
        {(t) => (
          <TooltipCommon
            key={`delete-mobile-app-link-tooltip-key-${this.props.linkId}`}
            overlayClassName="delete-mobile-app-link-tooltip__component"
            header={t("Delete App Link")}
            placement="bottom"
            trigger="click"
            visible={this.state.popupOpen}
            closeIcon
            onClose={this.onPopupClose}
            overlay={this.renderTooltipContent()}
          >
            {['desktop'].includes(this.props.device)  ?
              this.renderDeleteButtonDesktop()
              :
              this.renderDeleteButtonMobile()
            }
          </TooltipCommon>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    device: state.commonReducer.device,
  }
);

export default connect(
  mapStateToProps,
  {
    deleteMobileAppsLink,
  },
)(MobileAppDeleteIcon);
